import styled from 'styled-components';
import CloseGreyCircleFillSvg from './../assets/close-grey-circle-fill.svg';

const CloseCircleFillIcon = styled(
  CloseGreyCircleFillSvg as React.SFC<React.SVGProps<SVGSVGElement>>,
)(
  props => `
  width: ${props => props.width};
  height: ${props => props.height};
  fill: ${props => props.fill || props.theme.colors.goWhite.base};
  transform: ${props.transform || 'scale(1)'};
  cursor: pointer;
`,
);

export default CloseCircleFillIcon;
